import React, { useState } from 'react';
import { FaWallet, FaMobileAlt, FaCreditCard } from 'react-icons/fa';
import image from '../assets/QR.png';
import gpay from '../assets/gpay.jpeg';
import Phonepay from '../assets/Phonepay.png';
import Amazonpay from '../assets/amazonpay.png';
import paytm from '../assets/Paytm.png';
import ConfirmPayment from './ConfirmPayment'; // Import the ConfirmPayment component
import { Link } from 'react-router-dom';
import { IoMdArrowRoundBack } from 'react-icons/io'; // Import the back arrow icon

function PaymentMethods() {
  const [isModalOpen, setIsModalOpen] = useState(false); // State to manage the modal
  const [isContentBlurred, setIsContentBlurred] = useState(false); // State for background blur
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(null); // Track selected payment method

  const handleVerifyPayClick = () => {
    setIsModalOpen(true); // Open the modal
    setIsContentBlurred(true); // Apply blur to the background
  };

  const handleCloseModal = () => {
    setIsModalOpen(false); // Close the modal
    setIsContentBlurred(false); // Remove blur from the background
  };

  const handleProceed = () => {
    // Proceed with the payment logic (can be routed to a new page or API call)
    setIsModalOpen(false); // Close the modal after proceeding
    setIsContentBlurred(false); // Remove blur from the background
  };

  const handlePaymentMethodClick = (method) => {
    setSelectedPaymentMethod(method); // Update the selected payment method
  };

  return (
    <>
      {/* Back Button Outside of Main Content */}
      <Link to={'/walk-in/room-reservation'}>
        <button className="absolute mt-2 top-16 left-3 p-2 text-black hover:text-gray-300 font-semibold text-2xl z-10">
          <IoMdArrowRoundBack />
        </button>
      </Link>

      <div className="w-full h-screen bg-white relative">
        {/* Background Content */}
        <div className={`w-full h-full ${isContentBlurred ? 'blur-sm' : ''}`}>
          {/* Payment Section */}
          <div className="max-w-5xl mx-auto mt-9  p-6 bg-white rounded-md shadow-sm">
            <div className="bg-gray-200 text-black p-3 mb-6 rounded-md">
              <h2 className="text-xl font-semibold">Choose Your Payment Method</h2>
            </div>

            <div className="flex flex-col md:flex-row gap-6">
              {/* Payment Methods */}
              <div className="w-full md:w-1/3">
                <div className="bg-white rounded shadow-md divide-y divide-gray-300">
                  <button
                    className={`py-5 px-4 w-full text-left font-medium flex items-center gap-4 transition-all ${
                      selectedPaymentMethod === 'UPI' ? 'bg-gray-200' : 'hover:bg-gray-200'
                    }`}
                    onClick={() => handlePaymentMethodClick('UPI')}
                  >
                    <FaMobileAlt />
                    <Link to="/upi-payment">UPI</Link>
                  </button>
                  <button
                    className={`py-5 px-4 w-full text-left font-medium flex items-center gap-4 transition-all ${
                      selectedPaymentMethod === 'Credit/Debit/ATM Cards'
                        ? 'bg-gray-200'
                        : 'hover:bg-gray-200'
                    }`}
                    onClick={() => handlePaymentMethodClick('Credit/Debit/ATM Cards')}
                  >
                    <FaCreditCard />
                    <Link to="/card-payment">Credit/Debit/ATM Cards</Link>
                  </button>
                  <button
                    className={`py-5 px-4 w-full text-left font-medium flex items-center gap-4 transition-all ${
                      selectedPaymentMethod === 'Wallets' ? 'bg-gray-200' : 'hover:bg-gray-200'
                    }`}
                    onClick={() => handlePaymentMethodClick('Wallets')}
                  >
                    <FaWallet />
                    <Link to="/cash">Cash</Link>
                  </button>
                </div>
              </div>

              {/* UPI Payment Section */}
              <div className="w-full md:w-2/3 bg-white p-4 shadow-md">
                <h2 className="text-md font-bold mb-4">Pay Via QR Code</h2>
                <div className="flex flex-col md:flex-row gap-4">
                  {/* QR Code Section */}
                  <div className="w-full md:w-1/2 flex flex-col items-center">
                    <img src={image} alt="QR Code" className="w-36 h-36" />
                    <button className="mt-4 bg-[#1d42b0] text-white py-2 px-4 rounded shadow-md hover:text-black transition-all">
                      Generate QR Code
                    </button>
                  </div>

                  {/* Instruction Section */}
                  <div className="w-full md:w-1/2 flex flex-col justify-center text-sm">
                    <h3 className="font-medium text-black mb-4">How to pay through QR?</h3>
                    <ul className="list-disc list-inside space-y-2 text-gray-600">
                      <li>Open UPI App in your phone</li>
                      <li>Scan this QR code in your UPI App</li>
                      <li>Proceed to payment & enter UPI PIN</li>
                    </ul>
                    <p className="mt-7 text-gray-500">We accept all UPI apps:</p>
                    <div className="flex items-center space-x-2 mt-2">
                      <img src={gpay} alt="" style={{ width: '60px' }} />
                      <img src={Phonepay} alt="" style={{ width: '30px' }} />
                      <img src={Amazonpay} alt="" style={{ width: '50px', paddingLeft: '15px' }} />
                      <img src={paytm} alt="" style={{ width: '55px', paddingLeft: '15px' }} />
                    </div>
                  </div>
                </div>

                {/* UPI ID Section */}
                <div className="mt-6">
                  <label htmlFor="upiId" className="block text-md font-medium text-gray-700 mb-2">
                    Enter Your UPI ID
                  </label>
                  <div className="flex">
                    <input
                      type="text"
                      id="upiId"
                      className="border rounded border-gray-300 pl-16 pr-16"
                      placeholder="ex - mobilenumber@upi"
                    />
                    <select className="border rounded-md border-gray-300 pr-1 p-3 ml-1">
                      <option>ybl</option>
                      <option>paytm</option>
                      <option>gpay</option>
                    </select>
                  </div>
                </div>

                {/* Verify & Pay Button */}
                <div className="mt-6 text-right">
                  <button
                    className="bg-green-500 text-white py-3 w-full rounded shadow-md hover:text-black transition-all"
                    onClick={handleVerifyPayClick}
                  >
                    Verify & Pay
                  </button>
                </div>

                {/* Agreement Text */}
                <div className="mt-4 text-sm text-center text-gray-600">
                  <p>
                    By continuing, you agree to the{' '}
                    <a href="/rules" className="text-blue-500 hover:underline">
                      Rules
                    </a>
                    ,{' '}
                    <a href="/privacy-policy" className="text-blue-500 hover:underline">
                      Privacy Policy
                    </a>
                    ,{' '}
                    <a href="/user-agreement" className="text-blue-500 hover:underline">
                      User Agreement
                    </a>{' '}
                    and{' '}
                    <a href="/terms-conditions" className="text-blue-500 hover:underline">
                      Terms & Conditions
                    </a>{' '}
                    of Trip.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Modal for Confirm Payment */}
        {isModalOpen && (
          <ConfirmPayment
            onClose={handleCloseModal}
            onProceed={handleProceed}
            paymentMethod={selectedPaymentMethod} // Pass the selected payment method here
          />
        )}
      </div>
    </>
  );
}

export default PaymentMethods;
